import { Component, OnInit } from '@angular/core';
import { MasterBlogComponent } from '../../blog/master-blog/master-blog.component';

@Component({
  selector: 'app-news-blog',
  templateUrl: './news-blog.component.html',
})
export class NewsBlogComponent extends MasterBlogComponent {
  masterList = []
 
  ngOnInit(){
 
     super.ngOnInit()
     this.init()
   }
     async init(){
 
     this.masterList = await this.fetchMasterList()
     
   }
   fetchMasterList() {

    return this.ERPAPI.post('crm/newsevent/search', {
      // "keyword": ""
    }).then(res => res.object)
  }
}



// WEBPACK FOOTER //
// ./src/app/components/blog/news-blog/news-blog.component.ts